<template>
  <div class="flower">
    <app-header :background-name="'wallpaper_lahochi.jpg'">
      <h1>Stéphanie Lefebvre</h1>
      <h2>LaHoChi</h2>
    </app-header>

    <div class="content">
      <article>
        <img src="~@/assets/background/left-bach.png" alt="flower" class="flower left">
        <div class="bloc">
          <h1>C'est quoi le LaHoChi ?</h1>
          <p>
            Le LaHoChi est une technique <span>énergétique de soin très puissante</span> transmise par apposition
            des mains et amenant une très haute fréquence de lumière.
          </p>
          <p><span>« La »</span> fait référence à la Lumière, l’Amour et la Sagesse provenant des fréquences de Lumière les plus élèvées.</p>
          <p><span>« Ho »</span> renvoie au mouvement de cette énergie.</p>
          <p><span>« Chi »</span> correspond au principe de vie, l’énergie universelle de vie.</p>

          </br>
          <h1>Quels sont les bienfaits d’un soin LaHoChi ?</h1>
          <p>
            Le LaHoChi dissout les <span>blocages énergétiques</span> qu’ils soient d’ordre <span>physique, émotionnel ou
            psychique</span>. </br>
            La très haute vibration énergétique de ce soin permet d’augmenter
            progressivement notre taux vibratoire et d’élargir plus encore notre conscience. </br>
          </p>
          <p>
            Il est ainsi un très bon outil de développement personnel nous permettant d’avancer de plus en plus
            vers nous même.
          </p>
        </div>

        <img src="~@/assets/background/right-bach.png" alt="flower" class="flower right">
        <div class="bloc">
          <p>
            Le soin LaHoChi permet entre autre :
            <ul>
              <li>Une relaxation profonde</li>
              <li>Une diminution du stress</li>
              <li>Un soulagement des douleurs</li>
              <li>Une revitalisation du corps et de l’esprit</li>
              <li>Une stimulation du système immunitaire et de la résistance physique</li>
              <li>Un équilibrage des énergies subtiles du corps</li>
              <li>Une activation du système énergétique</li>
              <li>Une élimination des toxines</li>
              <li>Un accroissement du bien-être général</li>
              <li>Un développement des perceptions subtiles</li>  
            </ul>            
          </p>

          <br/>
          <h1>Comment se déroule une séance ?</h1>
          <p>
            La séance débute par un entretien avec le praticien, dans l’écoute et le respect. Puis le
            receveur est installé confortablement sur une table de massage. Le soin se réalise habillé. Le
            praticien appose ses mains sur 5 positions du corps au niveau de la tête, des clavicules, des
            épaules, des hanches et du cœur. D’autres positions peuvent être ajoutées localement en
            fonction des besoins du receveur. Puis, une position d’harmonisation globale du corps
            clôture le soin.
          </p>
          <p>
            Le Lahochi s’adresse à tous : enfants, adultes, femmes enceintes, personnes âgées. Il peut
            être utilisé seul ou en combinaison avec d’autres systèmes de soins et peut tout à fait venir
            compléter les soins ou suivis déjà en cours.
          </p>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
  import AppHeader from '@/components/Header'

  export default {
    name: 'Lahochi',
    components: { AppHeader }
  }
</script>

<style lang="scss" scoped>
  .flower {
    display: flex;
    flex-direction: column;
    flex: 1;

    .content {
      position: relative;
      text-align: center;
      background-color: #f1fae7;
      align-items: center;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      @media screen and (max-width: 680px) {
        overflow: auto;
      }
      h4 {
        width: 50%;
        margin: .5em;
        font-size: 1.1em;
        font-family: 'Delius', cursive;
        border-bottom: 2px solid $color-green;
        padding-bottom: 1em;
        font-weight: 700;
      }

      article {
        @include custom-article();
        img {
          position: absolute;
          z-index: 0;
          opacity: .5;

          &.left {
            bottom: 2vw;
            left: 3vw;
            transform: scaleX(-1);
          }

          &.right {
            top: 0;
            right: 3vw;
            transform: rotate(90deg);
          }
        }
      }
    }
  }
</style>
